import React from "react";
import PropTypes from "prop-types";
import { Card } from "antd";
import { Link } from "react-router-dom";
import ProjectExperienceAvatar from "../projects/ProjectExperienceAvatar";
import { Experience } from "../../types/Experience";
import { RoleTypes } from "../../types/RoleTypes";
import ProjectorLogo from "components/common/ProjectorLogo";

export type RoleTypeMap = RoleTypes & { experiences: Experience[] };

const RoleTypeExperienceCard = ({ roleType }: { roleType: RoleTypeMap }) => {
  // only display projector logo if all employee experiences are created by projector
  let projector = true;
  roleType.experiences.forEach((r: Experience) => {
    if (!r.projector) {
      projector = false;
    }
  });

  return (
    <Card className="avatar-card" hoverable={true}>
      {projector && (
        <div
          style={{
            float: "right",
            display: "flex",
            alignItems: "center",
            marginRight: "-20px",
            marginTop: "-14px"
          }}
        >
          <ProjectorLogo size="26px" />
        </div>
      )}
      <Link to={`/role-types/${roleType.id}`}>
        <Card.Meta
          title={roleType.name}
          description={<span>{roleType.family}</span>}
        />
      </Link>
      <Card.Meta
        description={
          <div
            style={{
              marginTop: "1.5em",
              overflowX: "auto",
              whiteSpace: "nowrap"
            }}
          >
            <ProjectExperienceAvatar experience={roleType.experiences} />
          </div>
        }
      />
    </Card>
  );
};

RoleTypeExperienceCard.propTypes = {
  skill: PropTypes.object
};

export default RoleTypeExperienceCard;
